import $ from 'jquery';
import log from 'log';
import * as i18n from 'i18n-setup';
import * as Overlay from 'overlay';
import isMobile from 'mobile';
import state from 'state';

export default function SignatureCanvas() {

    var me = this,
        polling = 500, // ms
        scalePressure = 8192,
        validIdentifier = /^[A-Za-z0-9]{22}$/, // keep in sync with Tablet.java
        $window = $(window),
        div = $('#sigOverlay'),
        cont = $('#sigContainer'),
        butOK = $('#sigOK'),
        butRedo = $('#sigRedo'),
        butCancel = $('#sigCancel'),
        txtSource = $('#sigSource'),
        canvas = document.getElementById('sigCanvas'),
        tablet = localStorage.w2s_tablet,
        tabletPossible = true,
        tabletXML = null,
        ctx = null,
        getTime = function (/*evt*/) { return Date.now(); },
        down, start, last, strokes, stroke, offset;

    me.clear = function () {
        log('clear');
        down = false;
        start = 0;
        last = [];
        strokes = [];
        stroke = null;
        tabletXML = null;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    function resize() {
        log('resize');
        canvas.width = cont.width();
        canvas.height = cont.height();
        me.clear();
        offset = cont.offset();
    }

    function browserInput() {
        div.show();
        resize();
        $window.on('resize', resize);
        listenEvents();
    }

    function checkTablet() {
        var opened = false,
            closed = false;
        function pollStatus(func) {
            return $.Deferred.delay(polling
            ).then(function () {
                return $.getJSON('tablet/status', { tablet: tablet });
            }).then(func);
        }
        function waitTablet(data) {
            if (!tabletPossible) {
                Overlay.closeOverlay();
                return { text: 'no tablet' };
            }
            if (closed)
                return { text: 'closed' };
            if ('error' in data) {
                if (!opened) {
                    var p = $(i18n.str('tablet.init.1').replace('{tablet}', tablet)),
                        a = $(i18n.str('tablet.init.2'));
                    p.append(a);
                    a.click(function (e) {
                        e.preventDefault();
                        tabletPossible = false;
                    });
                    opened = true;
                    Overlay.error(p, function (ev) {
                        Overlay.clickCloseOverlay(ev);
                        closed = ev.isDefaultPrevented();
                    });
                }
                return pollStatus(waitTablet);
            } else
                Overlay.closeOverlay();
            return data;
        }
        function waitXML(data) {
            log('DEBUG waitXML:', data);
            if (!('text' in data))
                throw new Error('Tablet servlet error.');
            if (data.text == 'ok') {
                tabletXML = 'tablet:' + tablet;
                butOK.click();
            } else if (data.text == 'cancel')
                butCancel.click();
            else
                return pollStatus(waitXML);
        }

        log('checkTablet');
        $.postJSON('tablet/id', { tablet: tablet ? tablet : '' }
        ).then(function (data) {
            if (!data.tablet) {
                log('Could not receive tablet id.');
                tablet = null;
                delete localStorage.w2s_tablet;
                throw new Error('Tablet servlet error.');
            }
            if (data.tablet != tablet)
                localStorage.w2s_tablet = tablet = data.tablet;
            return pollStatus(waitTablet);
        }).then(function (data) {
            if (data.text == 'closed') {
                log('Request was closed.');
                return;
            }
            if (data.text == 'no tablet') {
                log('No tablet was detected.');
                browserInput();
                return;
            }
            log('SUCCESS:', data);
            return $.ajax({
                url: 'tablet/action',
                dataType: 'json',
                method: 'POST',
                data: {
                    tablet: tablet,
                    text: 'start',
                    background: state.base + 'signature.png?field=' + encodeURIComponent(me.field)
                }
            }).then(function (data) {
                if ('error' in data)
                    throw new Error('Error sending action: ' + data.error);
                return pollStatus(waitXML);
            });
        }).catch(function (err) {
            log('ERROR:', err.stack);
            butCancel.click();
        });
    }

    me.get = function (tabletWanted, field, callback) {
        log('get');
        me.field = field;
        if (callback) {
            var called = false;
            me.callback = function (val) {
                log('callback');
                if (called) {
                    log('ERROR: callback invoked again, ignoring');
                    return;
                }
                callback(val);
                called = true;
            };
        }
        txtSource.i18n('src.browser');
        if (tabletWanted && tabletPossible) {
            checkTablet();
        } else {
            browserInput();
        }
    };

    me.generateXML = function () {
        log('generateXML');
        if (tabletXML)
            return tabletXML;
        var s = '<SigData><Device>' +
                '<Information>' +
                    '<VendorName>Andxor Web2Sign</VendorName>' +
                    '<VendorID>0</VendorID>' +
                    '<ProductName>' + navigator.userAgent + '</ProductName>' +
                    '<ProductID>0</ProductID>' +
                '</Information>' +
                '<Capabilities>' +
                    '<TFrequency>0</TFrequency>' +
                    '<XResolution>0</XResolution>' +
                    '<YResolution>0</YResolution>' +
                    '<XMax>' + canvas.width + '</XMax>' +
                    '<YMax>' + canvas.height + '</YMax>' +
                    '<PMax>' + scalePressure + '</PMax>' +
                '</Capabilities>' +
                '</Device>' +
                '<Time>' + start + '</Time>' +
                '<Strokes>';
        for (var i = 0; i < strokes.length; ++i) {
            s += '<Stroke>';
            var stroke = strokes[i];
            for (var j = 0; j < stroke.length; ++j) {
                var point = stroke[j];
                s += '<Point>' +
                    '<T>' + (point[0]|0) + '</T>' +
                    '<X>' + (point[1]|0) + '</X>' +
                    '<Y>' + (point[2]|0) + '</Y>' +
                    '<P>' + (point[3]|0) + '</P>' +
                    '</Point>';
            }
            s += '</Stroke>';
        }
        s += '</Strokes></SigData>';
        return s;
    };

    function getCoords(e) {
        if (e.targetTouches) e = e.targetTouches[0];
        return {
            x: e.pageX - offset.left,
            y: e.pageY - offset.top,
            p: Math.round((e.force || e.pressure || 0) * scalePressure) // scale from [0,1] float to integer
        };
        // e.t0.force defined in https://developer.mozilla.org/en-US/docs/Web/API/Touch/force
        // e.pressure defined in https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
    }

    function pointerDown(evt) {
        var now = getTime(evt);
        down = true;
        if (start === 0) start = now;
        if (evt.preventDefault) evt.preventDefault();
        if (evt.type.startsWith('touch')) {
            // disable mouse events since touch ones are working
            canvas.onmousedown = canvas.onmouseup = canvas.onmousemove = canvas.onmouseout = null;
        }
        var c = getCoords(evt),
            w = Math.min(2, c.p * 8 / scalePressure);
        stroke = [[now - start, c.x, c.y, c.p]];
        ctx.fillRect(c.x, c.y, w, w);
        ctx.lineCap = 'round';
        last = c;
        return false;
    }

    function pointerMove(evt) {
        var now = getTime(evt);
        if (evt.preventDefault) evt.preventDefault();
        if (down) {
            var c = getCoords(evt);
            stroke.push([now - start, c.x, c.y, c.p]);
            ctx.lineWidth = Math.min(2, c.p * 8 / scalePressure);
            ctx.beginPath();
            ctx.moveTo(last.x, last.y);
            ctx.lineTo(c.x, c.y);
            ctx.stroke();
            last = c;
        }
        return false;
    }

    function pointerUp(evt) {
        if (evt.preventDefault) evt.preventDefault();
        if (down) {
            try { pointerMove(evt); } catch (e) { /* seems that "touchend" doesn't send any point */ }
            down = false;
            strokes.push(stroke);
        }
        return false;
    }

    function listenEvents() {
        if ('ontouchstart' in document.documentElement) {
            canvas.ontouchstart = pointerDown;
            canvas.ontouchend = pointerUp;
            canvas.ontouchmove = pointerMove;
            canvas.ontouchleave = pointerUp;
            // we also listen to mouse events, as touch could be supported but not in use
            // we will remove mouse listening on first touch event actually received
        }
        canvas.onmousedown = pointerDown;
        canvas.onmouseup = pointerUp;
        canvas.onmousemove = pointerMove;
        canvas.onmouseout = pointerUp;
    }

    function ignoreEvents() {
        if ('ontouchstart' in document.documentElement) {
            canvas.ontouchstart = null;
            canvas.ontouchend = null;
            canvas.ontouchmove = null;
            canvas.ontouchleave = null;
        }
        canvas.onmousedown = null;
        canvas.onmouseup = null;
        canvas.onmousemove = null;
        canvas.onmouseout = null;
    }

    function cleanUp() {
        $window.off('resize', resize);
        ignoreEvents();
    }

    ctx = canvas.getContext('2d');

    butRedo.click(function () {
        me.clear();
    });

    butCancel.click(function () {
        div.hide();
        cleanUp();
        me.clear();
        if (me.callback)
            me.callback(false);
    });

    butOK.click(function () {
        // only accept OK if at least one point was received
        if (tabletXML) {
            // do nothing
        } else if (strokes.length < 1)
            return;
        // hide everything and callback if requested
        div.hide();
        cleanUp();
        if (me.callback)
            me.callback(true);
    });

    if (isMobile()) {
        tabletPossible = false;
        log('Mobile browser detected, Java will not be used.');
    }

    // normalize event timestamps
    (function () {
        var source;
        try {
            var now = Date.now(),
                evt = document.createEvent('KeyboardEvent');
            if (!evt.timeStamp) {
                source = 'date (missing)';
            } else if (evt.timeStamp > now * 900) {
                // https://bugzilla.mozilla.org/show_bug.cgi?id=77992#c40
                // Mozilla is erratic, just ignore the timestamp
                source = 'date (Mozilla bug)';
            } else if (evt.timeStamp < now) {
                var delta = now - evt.timeStamp;
                source = 'high performance with delta ' + delta;
                getTime = function (evt) { return Math.round(delta + evt.timeStamp); };
            } else {
                source = 'best effort';
                getTime = function (evt) { return evt.timeStamp || Date.now(); };
            }
        } catch (e) {
            source = 'date (exception: ' + e + ')';
        }
        log('Event timestamp:', source);
    })();
}
